import React from 'react';
import WatchReview from '../watchReview'


function DKnight(props) {

        return (
            <WatchReview 
                tube="https://www.youtube.com/embed/Keow0Vackx0" 
                blerb="Welcome to Brothers Sip and Talk S#@%, where we discuss all things horror and foreign...films. Over our next drink, we discuss cult classic 'Tales From The Crypt: DEMON KNIGHT'...Shout out to Jada for being a beast in this Black directed horror flop turned hit....and Billy Zane...did his thing!"
            />
        )
    }   

export default DKnight;
